const testimonials = [
  {
    id: 1,
    name: 'Dr. Bahubali Shiragapur',
    title: 'Director',
    org: 'DY Patil International University, Pune',
    desc: "As a mentor, I've known him for the past 5 years — he is an amazing candidate with versatile knowledge in coding and strong work ethics."
  },
  {
    id: 2,
    name: 'Mr. Soubhik Das',
    title: 'CEO',
    org: 'Manastik Pvt Ltd, Pune',
    desc:
      'Saksham maintained professionalism & discipline during the internship & managed to complete all the tasks as assigned. We enjoyed working with him in this short period.',
  },
  {
    id: 3,
    name: 'Mr. Sharad Goel',
    title: 'Managing Director',
    org: 'Essential Services Outsource Pvt Ltd, Ahmedabad',
    desc:
      'Saksham is a quick learner and very diligent towards the work assigned to him. He finished all of his tasks on time with exceptional quality.',
  },
];
export default testimonials;
